import {eventEmitter} from '../main'

export default {
  data () {
    return {
      valid: true,
      selectEngine: this.$store.state.metadata.selectEngines,
      rules: {
        required: value => (!!value || value === 0) || 'Required.',
        isNumber: value => /^-?\d+$/.test(value) || 'The value must be a number',
        isDecimal: value => /^-?\d+(\.\d)?/.test(value) || 'The value must be a number',
        numberSize: value => (value > 0 && value <= this.maxTop) || 'Top must be less than ' + this.maxTop,
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        },
        domainName: value => {
          const domainPattern = /^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/
          return domainPattern.test(value) || 'This value should be a valid url.'
        },
        anURL: value => {
          const domainPattern = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/gm
          return domainPattern.test(value) || 'This value should be a valid url.'
        }
      }
    }
  },
  created () {
    var self = this
    eventEmitter
      .$on('clearInsightForm', function handleFormClear () {
        self.resetForm()
      })
  },
  methods: {
    validate () {
      if (this.$refs.form.validate()) {
        this.formToResult()
        eventEmitter.$emit('submitInsight', this.result)
        // TODO implement sending of result to the server
        // this.$refs.form.reset()
        // this.$emit(this.closeAction)
        // this.resetForm()
        // TODO implement redirect to "My projects"
      }
    },
    stringToArray (strSeparated) {
      let result = []

      // check if there are some lines
      var match = /\r|\n/.exec(strSeparated)

      if (match) {
        let arrLines = strSeparated.match(/[^\r\n]+/g).join(',')
        result = arrLines.split(',').map((item) => { return item.trim() })
      } else {
        result = strSeparated.split(',').map((item) => { return item.trim() })
      }

      // remove empty values
      result = result.filter((item) => {
        return item != null && item !== ''
      })
      return result
    },
    closeDialog () {
      eventEmitter.$emit('closeInsightModal', this.name)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/insightMixin.js